/**
 * Created by sagardesai on 18/07/18.
 */

import React, {Component} from 'react';
import {formattedPrice, getFormattedPrice, isEmpty, vuepayAlert} from "../../util/utility";
import {getData, LOGIN, USER_DATA} from "../../util/storage";
import {
    cancelPrivateRequest,
    sendRequestForPrivateSession,
    updatePrivateSessionRequestStatus
} from "../../util/firebase/firestore";
//image
import loading_white from '../../assets/gif/loading_white.gif';
import connect from "react-redux/es/connect/connect";
import * as actions from "../../actions";
import {getMoneyBloxWalletBalance} from '../../assets/libs/MoneyBlox'
import {getUserProfile} from "../../util/business_logic";
import assets from "../../util/assets";

class PrivateSessionInviteModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            wallet_balance:"0.00"
        }
    }

    /**
     * @function This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {
        //MoneyBlox
        if (nextProps.moneyblox.hasOwnProperty("wallet_balance") &&
            nextProps.moneyblox.hasOwnProperty("user_details") &&
            nextProps.moneyblox.user_details !== null) {
            // //console.log(nextProps.moneyblox)
            this.setState({
                wallet_balance:this.props.moneyblox.wallet_balance
            })
        }
        if (this.props.isVisible !== nextProps.isVisible){
            if (nextProps.isVisible){
                getMoneyBloxWalletBalance(this.props, true);
            }
        }
    }

    sendPrivateRequestToBroadcaster = () => {

        if ((this.state.wallet_balance * 100) < this.props.broadcaster.broadcast[0].one_to_one_session_price) {
            vuepayAlert("error", `Please make sure to have at least ${formattedPrice(this.props.broadcaster.broadcast[0].one_to_one_session_price)} to join this session`);
            return
        }

        this.setState({
            isFetching: true
        },() => {

            //through API
            getData(LOGIN).then((data) => {
                if (!isEmpty(data)) {
                    let params = {
                        id: this.props.broadcaster.broadcast[0].id,
                        group: false,
                        onetoone: true,
                        wallet_balance: 1000,
                    };
                    this.props.requestAvailabilityBroadcast(
                        data.token,
                        data.api_token,
                        params
                    );

                    this.setState({
                        isFetching: false
                    })
                    this.props.togglePrivateRequestStatus()
                    this.props.togglePrivateSessionInviteModal()
                } else {
                    this.props.history.push({
                        pathname: "/login",
                        state: {basePath: this.props.history.location.pathname},
                    });
                }
            });

            //Firebase way
            // getData(USER_DATA)
            //     .then((data) => {
            //         if (!isEmpty(data)) {
            //             //console.log(data)
            //             sendRequestForPrivateSession(`${this.props.broadcaster.broadcast[0].id}`,data.user_id, {
            //                 "from":"viewer",
            //                 "created_at": Date.now(),
            //                 "updated_at": Date.now(),
            //                 "read": false,
            //                 "status": 0,
            //                 "username": data.username,
            //                 "profile_pic": getUserProfile(data.profile_pic)
            //             }, () => {
            //                 /**
            //                  * Update parent component about private request status
            //                  */
            //                 this.setState({
            //                     isFetching: false
            //                 })
            //                 this.props.togglePrivateRequestStatus()
            //                 this.props.togglePrivateSessionInviteModal()
            //             })
            //         }
            //     })
        })

    }

    cancelPrivateRequestSession = () => {

        this.setState({
            isFetching: true
        },() => {
            getData(USER_DATA)
                .then((data) => {
                    if (!isEmpty(data)) {
                        //console.log(data)
                        cancelPrivateRequest(`${this.props.broadcaster.broadcast[0].id}`,data.user_id, () => {
                            /**
                             * Update parent component about private request status
                             */
                            this.setState({
                                isFetching: false
                            })
                            if (this.props.isPrivateRequestReceived) {
                                this.props.togglePrivateRequestReceivedStatus()
                                this.props.togglePrivateSessionInviteModal()
                            }
                            else {
                                this.props.togglePrivateRequestStatus()
                                this.props.togglePrivateSessionInviteModal()
                            }
                        })
                    }
                })
        })
    }


    acceptPrivateSessionRequestReceived = () => {

        if ((this.state.wallet_balance * 100) < this.props.broadcaster.broadcast[0].one_to_one_session_price) {
            vuepayAlert("error", `Please make sure to have at least ${formattedPrice(this.props.broadcaster.broadcast[0].one_to_one_session_price)} to join this session`);
            return
        }

        getData(USER_DATA)
            .then((data) => {
                if (!isEmpty(data)) {

                    updatePrivateSessionRequestStatus(this.props.broadcaster.broadcast[0].id.toString(), data.user_id, 1, () => {
                        this.props.togglePrivateSessionInviteModal()
                    })
                }
            })
    }

    render() {
        return (
            <div id="private-session-invite-confirmation" className="modal fade" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                <div className="vertical-alignment-helper">
                    <div className="modal-dialog vertical-align-center">
                        <div className="modal-content">
                            <div className="modal-header">
                                {!this.props.isPrivateRequestReceived && <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.props.togglePrivateSessionInviteModal}>
                                    <img alt={"close-icon"} src={assets.broadcast.cross}/>
                                </button>}
                            </div>
                            <div className="modal-body">
                                <div className="followers-img-wrapper">
                                    <div className="followers-img">
                                        <img src={this.props.broadcaster.profile_pic} alt="followers"/>
                                    </div>
                                </div>
                                <h5>{this.props.broadcaster.username}</h5>
                                <p>
                                    {this.props.isPrivateRequestReceived ?
                                        "You have received a private session invite"
                                        :
                                        this.props.isPrivateRequestSent ?
                                        "You have requested a private session"
                                        :
                                        "You are requesting a private session"
                                    }
                                </p>
                                {/*<p className="font-weight-bold">Are you entering a ... session?</p>*/}
                                <div className="border-box">
                                    <p>Private session charge</p>
                                    <p><strong>{this.props.broadcaster.broadcast && this.props.broadcaster.broadcast[0].broadcast_type === 'free' ? "Free" : getFormattedPrice(this.props.broadcaster.broadcast[0].one_to_one_session_price)}</strong></p>
                                    <p className="mt-3">Your credit</p>
                                    {
                                        (this.state.wallet_balance === "0.00" || this.props.moneyblox.user_details === null)
                                            ?
                                            <p className="text-danger" style={{cursor: 'pointer'}} onClick={() => {
                                                this.props.showMoneyBloxModal()
                                            }}>£0.00</p>
                                            :
                                            <p><strong>£{this.state.wallet_balance}</strong></p>
                                    }
                                </div>
                            </div>
                            <div className="modal-footer">
                                {
                                    this.props.isPrivateRequestReceived ?
                                        (this.props.broadcaster.broadcast && this.props.broadcaster.broadcast[0].broadcast_type !== 'free' && this.state.wallet_balance === "0.00" || this.props.moneyblox.user_details === null) ?
                                            <button type="button" className="btn btn-outline-primary" disabled>Accept private invitation</button>
                                            :
                                            <button type="button" className="btn btn-outline-primary" onClick={this.acceptPrivateSessionRequestReceived}>
                                                {this.state.isFetching ?
                                                    <img src={loading_white} alt={"Loading"} width={26} height={26}/>
                                                    : "Accept private invitation"
                                                }
                                            </button>
                                        :
                                        this.props.isPrivateRequestSent ?
                                            <button type="button" className="btn btn-outline-primary"
                                                    onClick={this.cancelPrivateRequestSession}>
                                                {this.state.isFetching ?
                                                    <img src={loading_white} alt={"Loading"} width={26} height={26}/>
                                                    : "Cancel request"
                                                }
                                            </button>
                                            :
                                            (this.props.broadcaster.broadcast && this.props.broadcaster.broadcast[0].broadcast_type !== 'free' && (this.state.wallet_balance === "0.00" || this.props.moneyblox.user_details === null)) ?
                                                <button type="button" className="btn btn-outline-primary" disabled>Confirm private request</button>
                                                :
                                            <button type="button" className="btn btn-outline-primary"
                                                    onClick={this.sendPrivateRequestToBroadcaster}>
                                                {this.state.isFetching ?
                                                    <img src={loading_white} alt={"Loading"} width={26} height={26}/>
                                                    : "Confirm private request"
                                                }
                                            </button>
                                }

                                {
                                    (this.props.moneyblox.user_details === null) ?
                                        <button type="button" className="btn btn-link" style={{cursor:'not-allowed'}} disabled>Add Credit</button>
                                        :
                                        <button type="button" className="btn btn-link" onClick={() => {
                                            this.props.showMoneyBloxModal()
                                        }}>Add Credit</button>
                                }

                                {this.props.isPrivateRequestReceived ?
                                    <button type="button" className="btn btn-link" data-dismiss="modal" onClick={this.cancelPrivateRequestSession}>Reject
                                        invitation</button>
                                    :
                                    <button type="button" className="btn btn-link" data-dismiss="modal"
                                            onClick={this.props.togglePrivateSessionInviteModal}>Return to
                                        Session</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownParams) {
    return {
        device: state.device.payload,
        moneyblox: state.moneyblox

    };
}

export default connect(mapStateToProps, actions)(PrivateSessionInviteModal);